"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadGoogleAnalytics;
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const code = 'google_analytics';
function loadGoogleAnalytics(ga_code) {
  const exists = document.getElementById('front-gtag-manager');
  if (exists || !ga_code) return;

  // if (document.location.origin.includes('localhost')) return;

  if (document.location.origin.endsWith('.dev')) return;
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ga_code.trim();
  script.sync = true;
  script.id = 'front-ga-script';
  return new Promise(function (resolve, reject) {
    script.addEventListener('load', function () {
      gtag('js', new Date());
      gtag('config', ga_code.trim());
      _CookiesStore.default.update(function (store) {
        store['loaded_' + code] = true;
      });
    });
    document.body.appendChild(script);
  });
  function gtag() {
    (window.dataLayer || []).push(arguments);
  }
}
